import React from "react";
import { createContext, useContext, useState } from "react";

export const PlayerContext = createContext({
  currentTime: 0,
  seekPlayer: 0,
  setSeekPlayer: null,
  setCurrentTime: null,
});

export const PlayerProvider = (props) => {
  const [currentTime, setCurrentTime] = useState(0);

  const [seekPlayer, setSeekPlayer] = useState(0);

  return (
    <PlayerContext.Provider
      value={{
        currentTime,
        setCurrentTime,
        seekPlayer,
        setSeekPlayer,
      }}
    >
      {props.children}
    </PlayerContext.Provider>
  );
};
